import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useTable, usePagination, useRowSelect } from "react-table";
import classNames from "classnames";
import PageTitle from "../../components/common/PageTitle";

const Panel = ({ children }) => (
  <div className="bg-white rounded-lg shadow-lg p-4 border-t-4 border-primary mb-4">
    <div>{children}</div>
  </div>
);

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    );
  }
);

const AllUsers = () => {
  const data = React.useMemo(
    () => [
      {
        id: "Sean",
        col2: "World",
      },
      {
        id: "Peter",
        col2: "rocks",
      },
      {
        id: "David",
        col2: "you want",
      },
    ],
    []
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "User ID",
        accessor: "id",
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, usePagination, useRowSelect, (hooks) => {
      hooks.visibleColumns.push((cols) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
          width: 200,
          className: "w-10",
        },
        ...cols,
        {
          id: "actions",
          Header: <div />,
          Cell: ({ row }) => (
            <div className="text-right">
              <button className="px-2 py-1 rounded bg-primary text-white">
                Edit
              </button>
              <button className="ml-2 px-2 py-1 rounded bg-red-500 text-white">
                Remove
              </button>
              <button className="ml-2 px-2 py-1 rounded bg-blue-500 text-white">
                Activities Log
              </button>
            </div>
          ),
        },
      ]);
    });

  return (
    <>
      <PageTitle title="All Users" />
      <div className="mt-4">
        <div className="flex-1 mr-4">
          <Panel>
            <table {...getTableProps()} className="w-full">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    className="text-left border-b-2 border-gray-200"
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps()}
                        className={classNames(
                          "font-bold px-2",
                          column.className
                        )}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()} className="px-2 py-1">
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Panel>
        </div>
      </div>
    </>
  );
};

export default AllUsers;
